import {FieldValidator, FieldValidatorBuilder} from './types';

export const boolean: FieldValidatorBuilder<boolean> = (fallback = false) => ({
  is: (value): value is boolean => typeof value === 'boolean',
  fallback,
});

export const number: FieldValidatorBuilder<number> = (fallback = 0) => ({
  is: (value): value is number => typeof value === 'number',
  fallback,
});

export const string: FieldValidatorBuilder<string> = (fallback = '') => ({
  is: (value): value is string => typeof value === 'string',
  fallback,
});

export const stringUnion = <T extends string>(
  fallback: T,
  possibleValues: Array<T> | ReadonlyArray<T>,
): FieldValidator<T> => ({
  is: (value): value is T => {
    if (typeof value !== 'string') {
      return false;
    }
    return (possibleValues as ReadonlyArray<string>).includes(value);
  },
  fallback,
});

export const stringMap: FieldValidatorBuilder<Record<string, string>> = (
  fallback = {},
) => ({
  is: (value): value is Record<string, string> => {
    if (typeof value !== 'object') return false;

    if (Array.isArray(value)) return false;

    if (Object.getOwnPropertySymbols(value).length > 0) return false;

    return Object.getOwnPropertyNames(value).every(
      (prop) => typeof value[prop] === 'string',
    );
  },
  fallback,
});
